export default __webpack_public_path__ + "static/media/portfolio-hover-156.6417579d.jpg";